// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"X8-z","button":"Y8-z","disabled":"Z8-z","creditCard":"_8-z","wrapper":"a9-z"};